import { User, Phone, AlertTriangle, Building2 } from 'lucide-react';
import type { DirectoryResident } from '@yawi/types';

interface DirectoryCardProps {
  resident: DirectoryResident;
}

const relationshipLabels: Record<string, string> = {
  TITULAR: 'Titular',
  FAMILIAR: 'Familiar',
  INQUILINO: 'Inquilino',
  OTRO: 'Otro',
};

export const DirectoryCard = ({ resident }: DirectoryCardProps) => {
  return (
    <div className={`bg-white rounded-xl border p-4 shadow-sm hover:shadow-md transition-shadow ${
      resident.isDelinquent ? 'border-red-200 bg-red-50/30' : 'border-slate-200'
    }`}>
      <div className="flex items-start gap-3">
        {/* Avatar */}
        {resident.photoUrl ? (
          <img
            src={resident.photoUrl}
            alt={resident.name}
            className="w-12 h-12 rounded-full object-cover border-2 border-slate-200"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center">
            <User className="w-6 h-6 text-slate-400" />
          </div>
        )}

        {/* Info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-slate-800 truncate">{resident.name}</h3>
            {resident.isDelinquent && (
              <span title="Moroso">
                <AlertTriangle className="w-4 h-4 text-red-500 flex-shrink-0" />
              </span>
            )}
          </div>

          <div className="flex items-center gap-1 text-sm text-slate-500 mt-0.5">
            <Building2 className="w-3.5 h-3.5" />
            <span>{resident.unitName}</span>
            {resident.tower && <span className="text-slate-400">• Torre {resident.tower}</span>}
          </div>

          <span className="inline-block mt-1 px-2 py-0.5 bg-slate-100 text-slate-600 rounded text-xs">
            {relationshipLabels[resident.relationship] || resident.relationship}
          </span>

          {/* Contact */}
          {resident.phone && (
            <a
              href={`tel:${resident.phone}`}
              className="flex items-center gap-1.5 mt-2 text-sm text-primary-600 hover:underline"
            >
              <Phone className="w-4 h-4" />
              {resident.phone}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
